import { createAction, props } from '@ngrx/store';

export namespace HeadingActions {
  export const LoadSuggestions = createAction(
    '[Heading] Load Suggestions',
    props<{ partialTerm: string }>()
  );
  export const LoadSuggestionsSuccess = createAction(
    '[Heading] Load Suggestions Success',
    props<{ partialTerm: string; list: string[]; listStatistics: Record<string, string> }>()
  );
  export const LoadSuggestionsFail = createAction(
    '[Heading] Load Suggestions Fail',
    props<{ error: string | object }>()
  );

  export const SetMode = createAction(
    '[Heading] Set Mode',
    props<{ mode: 'AUTOCOMPLETE' | 'SIMILARITY' }>()
  );
}
